import { useIsMobile } from '@yes.technology/react-toolkit'
import useStyleMaps from 'site/Renderer/hooks/useStyleMap'
import { BannerImageProps } from './HeroBanner.types'

type BannerImageComponentProps = {
  image: BannerImageProps
}

const BannerImage = ({ image }: BannerImageComponentProps) => {
  const {
    desktop = { alt: '', url: '' },
    mobile = { alt: '', url: '' },
    styleMap = {}
  } = image ?? {}

  const isMobile = useIsMobile()
  const style = useStyleMaps(styleMap)

  const { url, alt } = isMobile ? mobile : desktop

  if (!url) {
    return null
  }

  return (
    <div className='d-flex justify-content-center align-items-center'>
      <img src={url} alt={alt} style={style} />
    </div>
  )
}

export default BannerImage
